(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-1"]) return;
  try {
     
jQuery(document).ready(function($) {
    function unlockBody() {
        $('body').removeClass('menu_open').css({'overflow': '','position': '','width': '','height': ''});
        $('html').css('overflow', '');
    }

    /* BUSCADOR MÓVIL */
    $('#open_mobile_search').on('click', function(e) {
        e.preventDefault();
        $('#mobile_search_dropdown').addClass('is-visible');
        setTimeout(function(){ $('.custom_mobile_search_input').focus(); }, 300);
    });

    $('#close_mobile_search').on('click', function() {
        $('#mobile_search_dropdown').removeClass('is-visible');
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('#mobile_search_dropdown').length && !$(e.target).closest('#open_mobile_search').length) {
            $('#mobile_search_dropdown').removeClass('is-visible');
        }
    });

    /* MENÚ MÓVIL */
    $('#megamenu_mobile_toggle').on('click', function(e) {
        e.preventDefault();
        $('#megamenu').addClass('active');
        $('body').addClass('menu_open').css('overflow', 'hidden');
    });

    $('.mobile_menu_overlay').on('click', function() {
        $('#megamenu').removeClass('active');
        unlockBody();
    });

    $('.megamenu_trigger').on('click', function(e) {
        if ($(window).width() <= 991) {
            e.preventDefault();
            e.stopPropagation();
            var $this = $(this);
            var $parent_li = $this.closest('.level_1__item');
            var $submenu = $parent_li.find('.level_2');
            $this.toggleClass('active');
            $submenu.slideToggle(300);
        }
    });

    $(document).on('click', '.level_1__link', function(e) {
        if($(window).width() <= 991 && $(this).attr('href') !== '#' && !$(e.target).hasClass('megamenu_trigger')) {
            $('#megamenu').removeClass('active');
            unlockBody();
        }
    });

    $(window).on('resize', function() {
        if ($(window).width() > 991) {
            $('#megamenu').removeClass('active');
            $('#mobile_search_dropdown').removeClass('is-visible');
            $('.level_2').removeAttr('style');
            $('.megamenu_trigger').removeClass('active');
            unlockBody();
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-divider"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
	if ( $(window).width() > 991 ) {
		$('.tablet_show').css('display', 'none');
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-newsletter"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
    
    $('.contact-form').each(function (){      
        $(this).on('submit', function(e){
            var formCookie = $(this).attr('class');
            $.cookie('formSended', formCookie);
        });
    });
    
    if( document.location.href.indexOf('?customer_posted=true') > 0) {
        $('.form_wrapper_modern').hide();
        $('.newsletter_column_text .form_text').hide();
        $('.alert-success').removeClass('hidden').show();
    };

    if ($.isFunction($.fn.formValidation)) {
        $('#newsletter_form').formValidation();
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-products-carousel"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
	$('.products_carousel').each(function(i) {

		var sliderId = '#' + $(this).attr('id');
		var sliderVar = $(this).attr('id');
		var sliderPagination = '#pagination_' + sliderVar.replace('products_carousel_', '');

		var carouselVar = new Swiper( sliderId, {
			effect: 'slide',
			slidesPerView: 5,
			spaceBetween: 20,
			speed: 500,
			autoplayDisableOnInteraction: false,
			breakpoints: {
				576: {
					slidesPerView: 1
				},
				768: {
					slidesPerView: 2
				},
				992: {
					slidesPerView: 4
				},
				1200: {
					slidesPerView: 5
				}
			},
			pagination: {
				el: sliderPagination,
				type: 'bullets',
				clickable: true,
			},
		});

	});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-slideshow"] && !Shopify.designMode) return;
  try {
     
jQuery(document).ready(function($) {
	$('.section_slideshow').each(function(i) { 

		var sliderId = '#' + $(this).attr('id');
		var sliderVar = $(this).attr('id');
		var sliderPagination = '#pagination_' + sliderVar.replace('slideshow_', '');
		var sliderPrev = '#slider_prev_' + sliderVar.replace('slideshow_', '');
		var sliderNext = '#slider_next_' + sliderVar.replace('slideshow_', '');
		var sliderEffect = $(this).data('effect');
		var sliderPagType = $(this).data('pagination');
		var sliderAutoplay = $(this).data('autoplay');
	

		var settings = {
			effect: sliderEffect,
			speed: 500,
			pagination: {
				el: sliderPagination
			},
			navigation: {
				nextEl: sliderNext,
				prevEl: sliderPrev
			}
		};

		if ( sliderAutoplay == true ) {
			sliderAutoplay = $(this).data('speed');
			settings.autoplay = {delay: sliderAutoplay};
		};

		if ( sliderPagType == 'dynamicBullets' ){
			settings.pagination.dynamicBullets = true;
			settings.pagination.clickable = true;
		} else if ( sliderPagType == 'progressbar' ){
			settings.pagination.type = 'progressbar';
		} else if ( sliderPagType == 'fraction' ){
			settings.pagination.type = 'fraction';
		}

		var sliderVar = new Swiper( sliderId, settings );


		$(window).on('resize', function() {
			sliderVar.updateSize(); // updating swiper after loading
		});
		

		// VIDEO SLIDE
		$(this).find('.video_slide').each(function(i) { 
			$(this).YTPlayer();
		});

	});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.sidebar-wrapper');
    const toggleBtn = document.getElementById('sidebar-toggle');
    const overlay = document.querySelector('.sidebar-overlay');
    const body = document.body;

    function toggleSidebar() {
        if(!wrapper) return;
        wrapper.classList.toggle('active');
        body.classList.toggle('sidebar-open');
    }

    if (toggleBtn) {
        toggleBtn.addEventListener('click', toggleSidebar);
    }

    if (overlay) {
        overlay.addEventListener('click', toggleSidebar);
    }

    body.addEventListener('click', function(e) {
        if (e.target.closest('.menu_trigger')) {
            const trigger = e.target.closest('.menu_trigger');
            const targetId = trigger.getAttribute('data-target');
            const targetMenu = document.getElementById(targetId);
            if (targetMenu.style.display === 'none' || targetMenu.style.display === '') {
                targetMenu.style.display = 'block';
                trigger.textContent = '−';
            } else {
                targetMenu.style.display = 'none';
                trigger.textContent = '+';
            }
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-account"]) return;
  try {
     
jQuery(document).ready(function($) {

	var section_wrapper = $('#account_customer__wrapper');
	var section_info = $('#account_section__info');
	var section_orders = $('#account_section__orders');

	// INFO
	$('#customer_account__info').on('click', function(e) {
		e.preventDefault();
		section_wrapper.fadeOut(200);
		section_info.fadeIn(200);
	});
	$('.account_account__close').on('click', function(e) {
		e.preventDefault();
		section_info.fadeOut(200);
		section_wrapper.fadeIn(200);

	}); 

	
	// ORDERS
	$('#customer_account__order').on('click', function(e) {
		e.preventDefault();
		section_wrapper.fadeOut(200);
		section_orders.fadeIn(200);
	});
	$('.account_order__close').on('click', function(e) {
		e.preventDefault();
		section_orders.fadeOut(200);
		section_wrapper.fadeIn(200);

	}); 



});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-addresses"]) return;
  try {
    
jQuery(document).ready(function($) {
	// ADD NEW ADDRESS
	$('#address_add, #address_add__close').hide();

	$('#address_add__link').on('click', function(e) {
		e.preventDefault();

		$(this).fadeOut(300);
		$('#address_add__close').delay(300).fadeIn();
		$('#address_add').slideDown();
	});

	$('#address_add__close, #address_add__cancel').on('click', function(e) {
		e.preventDefault();

		$('#address_add__close').fadeOut(300);
		$('#address_add__link').delay(300).fadeIn();
		$('#address_add').slideUp();
	});


	// EDIT EXISTING ADDRESS
	$('.account_address__edit').hide();
	$('.account_address__item .link_close').hide();

	$('.link_edit').on('click', function(e) {
		e.preventDefault();

		var t = $(this).attr('href');

		$(t).find('.account_address__edit').slideDown();

		$(this).fadeOut(300);

		$(t).find('.link_close').delay(300).fadeIn();

		$(t).find('.link_close').on('click', function(event) {
			event.preventDefault();

			$(t).find('.account_address__edit').slideUp();

			$(this).fadeOut(300);

			$(t).find('.link_edit').delay(300).fadeIn();
		});

		$(t).find('.link_cancel').on('click', function(event) {
			event.preventDefault();

			$(t).find('.link_close').trigger('click');
		});

	});


	// DELETING ADDRESS
	$('.link_delete').on('click', function() {
		Shopify.CustomerAddress.destroy( $(this).attr('title') );
	});

});


// PROVINCES SELECTS
new Shopify.CountryProvinceSelector( 'address_country_new', 'address_province_new', { hideElement: 'address_province_container_new' } );

var customerAddresses = JSON.parse( theme.customerAddresses );

for ( i=0; i<customerAddresses.length; i++ ) {
	var addressCountry = 'address_country_' + customerAddresses[i].id;
	var addressProvince = 'address_province_' + customerAddresses[i].id;
	var addressProvinceHide = 'address_province_container_' + customerAddresses[i].id;

	new Shopify.CountryProvinceSelector( addressCountry, addressProvince, { hideElement: addressProvinceHide } );

};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-collection"]) return;
  try {
    
jQuery(document).ready(function($) {
    if ( typeof $.cookie('productSortView') == 'undefined' ) {
        $.cookie('productSortView', 'grid', {path: '/'});
    } else if ( $.cookie('productSortView') == 'list' ) {
        $('#view_grid').removeClass('active');
        $('#view_list').addClass('active');
        $('#product_listing__sorted').addClass('product_listing__list');
    }

    $('#view_grid, #view_list').on('click', function() {
        var thisView = $(this).data('view');
        $('#view_grid, #view_list').removeClass('active');
        $('#product_listing__sorted').removeClass('product_listing__list product_listing__grid');
        $(this).addClass('active');
        $.cookie('productSortView', thisView, {path: '/'});
        $('#product_listing__sorted').addClass( 'product_listing__' + thisView );
    });

    $('#sort_by_select').on('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', $(this).val());
        url.searchParams.set('page', '1');
        window.location.href = url.href;
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-contact-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reset(b) {
    b.disabled = false;
    var l = b.querySelector('.ncf-btn__label');
    if (l && b.dataset.label) l.textContent = b.dataset.label;
  }

  // Estado "enviando" (solo se ejecuta si el formulario pasó la validación nativa)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('ncf-form')) return;
    var b = f.querySelector('.ncf-btn');
    if (!b) return;
    var l = b.querySelector('.ncf-btn__label');
    b.dataset.label = l ? l.textContent : '';
    if (l && b.dataset.loading) l.textContent = b.dataset.loading;
    b.disabled = true;
  });

  // Si el usuario vuelve atrás, el botón no debe quedar bloqueado
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('.ncf-btn').forEach(reset);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-login"]) return;
  try {
     
jQuery(document).ready(function($) {

	// TRACK ACCOUNT FORM 
	$('.template_customer form').each(function (){      
		$(this).on('submit', function(e){
			var formCookie = $(this).attr('id');
			$.cookie('accountForm', formCookie);
		});
	});

	var section_wrapper = $('#account_section__wrapper');
	var section_login = $('#account_section__login');
	var section_register = $('#account_section__register');
	var section_reset = $('#account_section__reset');

	// HIDE/SHOW FORM
	if ( section_login.find('.alert').length && $.cookie('accountForm') == 'customer_login' ) {  
		section_wrapper.hide();
		section_login.show();
		section_register.find('.alert').remove();

	} else if ( $('#account_section__register').find('.alert').length  && $.cookie('accountForm') == 'create_customer' ) {
		section_register.show();
		section_wrapper.hide();
		section_login.find('.alert').remove();

	} else if ( section_reset.find('.alert').length ) {
		section_wrapper.hide();
		section_reset.show();
	};

	// LOGIN
	$('#account_login__link').on('click', function(e) {
		e.preventDefault();
		section_wrapper.fadeOut(200);
		section_login.fadeIn(200);
	});
	$('.account_login__close').on('click', function(e) {
		e.preventDefault();
		section_login.fadeOut(200);
		section_wrapper.fadeIn(200);

	});

	// LOGIN GUEST 
	$('#account_login_guest__link').on('click', function(e) {
		e.preventDefault();
		section_wrapper.fadeOut(200);
		$('#account_section__login_guest').fadeIn(200);
	});
	$('.account_login_guest__close').on('click', function(e) {
		e.preventDefault();
		$('#account_section__login_guest').fadeOut(200);
		section_wrapper.fadeIn(200);

	});

	// REGISTER
	$('#account_register__link').on('click', function(e) {
		e.preventDefault();
		section_wrapper.fadeOut(200);
		section_register.fadeIn(200);
	});
	$('.account_register__close').on('click', function(e) {
		e.preventDefault();
		section_register.fadeOut(200);
		section_wrapper.fadeIn(200);

	});

	// RESET
	$('#account_reset__link').on('click', function(e) {
		e.preventDefault();
		section_reset.fadeIn(200);
		section_wrapper.fadeOut(200);
	});
	$('.account_reset__cancel').on('click', function(e) {
		e.preventDefault();
		section_reset.fadeOut(200);
		section_wrapper.fadeIn(200);
	});
	if ( document.location.href.indexOf( '#recover' ) !== -1 ) {
		section_reset.show();
		section_wrapper.hide();
	};

	// VALIDATION
	$('#create_customer').formValidation();
	$('#create_customer').on('submit', function() {
		$('#password_confirmed').val( $('#password_1').val() );
	});

	$('#customer_login').formValidation();
	$('#account_section__activation form').formValidation();
	$('#account_section__reset-account form').formValidation();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-password"]) return;
  try {
    
	// jQuery Circular CountDown - https://github.com/nikhiln/Circular-Countdown
		!function(e){e.fn.ccountdown=function(a,t,n,r,d){var o,g=this,i=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"),c=(new Date,function(){var c=new Date,u=c.getYear();1e3>u&&(u+=1900);var h=c.getMonth(),l=c.getDate(),f=c.getHours(),s=c.getMinutes(),_=c.getSeconds();_="0"+_,_=_.substr(_.length-2);var v=i[h]+" "+l+", "+u+" "+f+":"+s+":"+_,M=i[t-1]+" "+n+", "+a+" "+r;_dd=Date.parse(M)-Date.parse(v),_dday=Math.floor(_dd/864e5*1),_dhour=Math.floor(_dd%864e5/36e5*1),_dmin=Math.floor(_dd%864e5%36e5/6e4*1),_dsec=Math.floor(_dd%5184e6%36e5%6e4/1e3*1);var y=e(g),w=y.find(".second"),D=y.find(".minute"),p=y.find(".hour"),m=y.find(".days");w.val(_dsec).trigger("change"),D.val(_dmin).trigger("change"),p.val(_dhour).trigger("change"),m.val(_dday).trigger("change"),0==_dd&&(window.clearInterval(o),"function"==typeof d&&d.call(this))});c(),o=setInterval(c,1e3)}}(jQuery);

	// jQuery Knob - https://github.com/aterrien/jQuery-Knob
		!function(t){"object"==typeof exports?module.exports=t(require("jquery")):"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)}(function(t){"use strict";var i={},s=Math.max,h=Math.min;i.c={},i.c.d=t(document),i.c.t=function(t){return t.originalEvent.touches.length-1},i.o=function(){var s=this;this.o=null,this.$=null,this.i=null,this.g=null,this.v=null,this.cv=null,this.x=0,this.y=0,this.w=0,this.h=0,this.$c=null,this.c=null,this.t=0,this.isInit=!1,this.fgColor=null,this.pColor=null,this.dH=null,this.cH=null,this.eH=null,this.rH=null,this.scale=1,this.relative=!1,this.relativeWidth=!1,this.relativeHeight=!1,this.$div=null,this.run=function(){var i=function(t,i){var h;for(h in i)s.o[h]=i[h];s._carve().init(),s._configure()._draw()};if(!this.$.data("kontroled")){if(this.$.data("kontroled",!0),this.extend(),this.o=t.extend({min:void 0!==this.$.data("min")?this.$.data("min"):0,max:void 0!==this.$.data("max")?this.$.data("max"):100,stopper:!0,readOnly:this.$.data("readonly")||"readonly"===this.$.attr("readonly"),cursor:this.$.data("cursor")===!0&&30||this.$.data("cursor")||0,thickness:this.$.data("thickness")&&Math.max(Math.min(this.$.data("thickness"),1),.01)||.35,lineCap:this.$.data("linecap")||"butt",width:this.$.data("width")||200,height:this.$.data("height")||200,displayInput:null==this.$.data("displayinput")||this.$.data("displayinput"),displayPrevious:this.$.data("displayprevious"),fgColor:this.$.data("fgcolor")||"#87CEEB",inputColor:this.$.data("inputcolor"),font:this.$.data("font")||"Arial",fontWeight:this.$.data("font-weight")||"bold",inline:!1,step:this.$.data("step")||1,rotation:this.$.data("rotation"),draw:null,change:null,cancel:null,release:null,format:function(t){return t},parse:function(t){return parseFloat(t)}},this.o),this.o.flip="anticlockwise"===this.o.rotation||"acw"===this.o.rotation,this.o.inputColor||(this.o.inputColor=this.o.fgColor),this.$.is("fieldset")?(this.v={},this.i=this.$.find("input"),this.i.each(function(i){var h=t(this);s.i[i]=h,s.v[i]=s.o.parse(h.val()),h.bind("change blur",function(){var t={};t[i]=h.val(),s.val(s._validate(t))})}),this.$.find("legend").remove()):(this.i=this.$,this.v=this.o.parse(this.$.val()),""===this.v&&(this.v=this.o.min),this.$.bind("change blur",function(){s.val(s._validate(s.o.parse(s.$.val())))})),!this.o.displayInput&&this.$.hide(),this.$c=t(document.createElement("canvas")).attr({width:this.o.width,height:this.o.height}),this.$div=t('<div style="'+(this.o.inline?"display:inline;":"")+"width:"+this.o.width+"px;height:"+this.o.height+'px;"></div>'),this.$.wrap(this.$div).before(this.$c),this.$div=this.$.parent(),"undefined"!=typeof G_vmlCanvasManager&&G_vmlCanvasManager.initElement(this.$c[0]),this.c=this.$c[0].getContext?this.$c[0].getContext("2d"):null,!this.c)throw{name:"CanvasNotSupportedException",message:"Canvas not supported. Please use excanvas on IE8.0.",toString:function(){return this.name+": "+this.message}};return this.scale=(window.devicePixelRatio||1)/(this.c.webkitBackingStorePixelRatio||this.c.mozBackingStorePixelRatio||this.c.msBackingStorePixelRatio||this.c.oBackingStorePixelRatio||this.c.backingStorePixelRatio||1),this.relativeWidth=this.o.width%1!==0&&this.o.width.indexOf("%"),this.relativeHeight=this.o.height%1!==0&&this.o.height.indexOf("%"),this.relative=this.relativeWidth||this.relativeHeight,this._carve(),this.v instanceof Object?(this.cv={},this.copy(this.v,this.cv)):this.cv=this.v,this.$.bind("configure",i).parent().bind("configure",i),this._listen()._configure()._xy().init(),this.isInit=!0,this.$.val(this.o.format(this.v)),this._draw(),this}},this._carve=function(){if(this.relative){var t=this.relativeWidth?this.$div.parent().width()*parseInt(this.o.width)/100:this.$div.parent().width(),i=this.relativeHeight?this.$div.parent().height()*parseInt(this.o.height)/100:this.$div.parent().height();this.w=this.h=Math.min(t,i)}else this.w=this.o.width,this.h=this.o.height;return this.$div.css({width:this.w+"px",height:this.h+"px"}),this.$c.attr({width:this.w,height:this.h}),1!==this.scale&&(this.$c[0].width=this.$c[0].width*this.scale,this.$c[0].height=this.$c[0].height*this.scale,this.$c.width(this.w),this.$c.height(this.h)),this},this._draw=function(){var t=!0;s.g=s.c,s.clear(),s.dH&&(t=s.dH()),t!==!1&&s.draw()},this._touch=function(t){var h=function(t){var i=s.xy2val(t.originalEvent.touches[s.t].pageX,t.originalEvent.touches[s.t].pageY);i!=s.cv&&(s.cH&&s.cH(i)===!1||(s.change(s._validate(i)),s._draw()))};return this.t=i.c.t(t),h(t),i.c.d.bind("touchmove.k",h).bind("touchend.k",function(){i.c.d.unbind("touchmove.k touchend.k"),s.val(s.cv)}),this},this._mouse=function(t){var h=function(t){var i=s.xy2val(t.pageX,t.pageY);i!=s.cv&&(s.cH&&s.cH(i)===!1||(s.change(s._validate(i)),s._draw()))};return h(t),i.c.d.bind("mousemove.k",h).bind("keyup.k",function(t){if(27===t.keyCode){if(i.c.d.unbind("mouseup.k mousemove.k keyup.k"),s.eH&&s.eH()===!1)return;s.cancel()}}).bind("mouseup.k",function(){i.c.d.unbind("mousemove.k mouseup.k keyup.k"),s.val(s.cv)}),this},this._xy=function(){var t=this.$c.offset();return this.x=t.left,this.y=t.top,this},this._listen=function(){return this.o.readOnly?this.$.attr("readonly","readonly"):(this.$c.bind("mousedown",function(t){t.preventDefault(),s._xy()._mouse(t)}).bind("touchstart",function(t){t.preventDefault(),s._xy()._touch(t)}),this.listen()),this.relative&&t(window).resize(function(){s._carve().init(),s._draw()}),this},this._configure=function(){return this.o.draw&&(this.dH=this.o.draw),this.o.change&&(this.cH=this.o.change),this.o.cancel&&(this.eH=this.o.cancel),this.o.release&&(this.rH=this.o.release),this.o.displayPrevious?(this.pColor=this.h2rgba(this.o.fgColor,"0.4"),this.fgColor=this.h2rgba(this.o.fgColor,"0.6")):this.fgColor=this.o.fgColor,this},this._clear=function(){this.$c[0].width=this.$c[0].width},this._validate=function(t){var i=~~((0>t?-.5:.5)+t/this.o.step)*this.o.step;return Math.round(100*i)/100},this.listen=function(){},this.extend=function(){},this.init=function(){},this.change=function(){},this.val=function(){},this.xy2val=function(){},this.draw=function(){},this.clear=function(){this._clear()},this.h2rgba=function(t,i){var s;return t=t.substring(1,7),s=[parseInt(t.substring(0,2),16),parseInt(t.substring(2,4),16),parseInt(t.substring(4,6),16)],"rgba("+s[0]+","+s[1]+","+s[2]+","+i+")"},this.copy=function(t,i){for(var s in t)i[s]=t[s]}},i.Dial=function(){i.o.call(this),this.startAngle=null,this.xy=null,this.radius=null,this.lineWidth=null,this.cursorExt=null,this.w2=null,this.PI2=2*Math.PI,this.extend=function(){this.o=t.extend({bgColor:this.$.data("bgcolor")||"#EEEEEE",angleOffset:this.$.data("angleoffset")||0,angleArc:this.$.data("anglearc")||360,inline:!0},this.o)},this.val=function(t,i){return null==t?this.v:(t=this.o.parse(t),void(i!==!1&&t!=this.v&&this.rH&&this.rH(t)===!1||(this.cv=this.o.stopper?s(h(t,this.o.max),this.o.min):t,this.v=this.cv,this.$.val(this.o.format(this.v)),this._draw())))},this.xy2val=function(t,i){var e,n;return e=Math.atan2(t-(this.x+this.w2),-(i-this.y-this.w2))-this.angleOffset,this.o.flip&&(e=this.angleArc-e-this.PI2),this.angleArc!=this.PI2&&0>e&&e>-.5?e=0:0>e&&(e+=this.PI2),n=e*(this.o.max-this.o.min)/this.angleArc+this.o.min,this.o.stopper&&(n=s(h(n,this.o.max),this.o.min)),n},this.listen=function(){var i,e,n,a,o=this,r=function(t){t.preventDefault();var n=t.originalEvent,a=n.detail||n.wheelDeltaX,r=n.detail||n.wheelDeltaY,l=o._validate(o.o.parse(o.$.val()))+(a>0||r>0?o.o.step:0>a||0>r?-o.o.step:0);l=s(h(l,o.o.max),o.o.min),o.val(l,!1),o.rH&&(clearTimeout(i),i=setTimeout(function(){o.rH(l),i=null},100),e||(e=setTimeout(function(){i&&o.rH(l),e=null},200)))},l=1,c={37:-o.o.step,38:o.o.step,39:o.o.step,40:-o.o.step};this.$.bind("keydown",function(i){var e=i.keyCode;if(e>=96&&105>=e&&(e=i.keyCode=e-48),n=parseInt(String.fromCharCode(e)),isNaN(n)&&(13!==e&&8!==e&&9!==e&&189!==e&&(190!==e||o.$.val().match(/\./))&&i.preventDefault(),t.inArray(e,[37,38,39,40])>-1)){i.preventDefault();var r=o.o.parse(o.$.val())+c[e]*l;o.o.stopper&&(r=s(h(r,o.o.max),o.o.min)),o.change(o._validate(r)),o._draw(),a=window.setTimeout(function(){l*=2},30)}}).bind("keyup",function(){isNaN(n)?a&&(window.clearTimeout(a),a=null,l=1,o.val(o.$.val())):o.$.val()>o.o.max&&o.$.val(o.o.max)||o.$.val()<o.o.min&&o.$.val(o.o.min)}),this.$c.bind("mousewheel DOMMouseScroll",r),this.$.bind("mousewheel DOMMouseScroll",r)},this.init=function(){(this.v<this.o.min||this.v>this.o.max)&&(this.v=this.o.min),this.$.val(this.v),this.w2=this.w/2,this.cursorExt=this.o.cursor/100,this.xy=this.w2*this.scale,this.lineWidth=this.xy*this.o.thickness,this.lineCap=this.o.lineCap,this.radius=this.xy-this.lineWidth/2,this.o.angleOffset&&(this.o.angleOffset=isNaN(this.o.angleOffset)?0:this.o.angleOffset),this.o.angleArc&&(this.o.angleArc=isNaN(this.o.angleArc)?this.PI2:this.o.angleArc),this.angleOffset=this.o.angleOffset*Math.PI/180,this.angleArc=this.o.angleArc*Math.PI/180,this.startAngle=1.5*Math.PI+this.angleOffset,this.endAngle=1.5*Math.PI+this.angleOffset+this.angleArc;var t=s(String(Math.abs(this.o.max)).length,String(Math.abs(this.o.min)).length,2)+2;this.o.displayInput&&this.i.css({width:(this.w/2+4>>0)+"px",height:(this.w/3>>0)+"px",position:"absolute","vertical-align":"middle","margin-top":(this.w/3>>0)+"px","margin-left":"-"+(3*this.w/4+2>>0)+"px",border:0,background:"none",font:this.o.fontWeight+" "+(this.w/t>>0)+"px "+this.o.font,"text-align":"center",color:this.o.inputColor||this.o.fgColor,padding:"0px","-webkit-appearance":"none"})||this.i.css({width:"0px",visibility:"hidden"})},this.change=function(t){this.cv=t,this.$.val(this.o.format(t))},this.angle=function(t){return(t-this.o.min)*this.angleArc/(this.o.max-this.o.min)},this.arc=function(t){var i,s;return t=this.angle(t),this.o.flip?(i=this.endAngle+1e-5,s=i-t-1e-5):(i=this.startAngle-1e-5,s=i+t+1e-5),this.o.cursor&&(i=s-this.cursorExt)&&(s+=this.cursorExt),{s:i,e:s,d:this.o.flip&&!this.o.cursor}},this.draw=function(){var t,i=this.g,s=this.arc(this.cv),h=1;i.lineWidth=this.lineWidth,i.lineCap=this.lineCap,"none"!==this.o.bgColor&&(i.beginPath(),i.strokeStyle=this.o.bgColor,i.arc(this.xy,this.xy,this.radius,this.endAngle-1e-5,this.startAngle+1e-5,!0),i.stroke()),this.o.displayPrevious&&(t=this.arc(this.v),i.beginPath(),i.strokeStyle=this.pColor,i.arc(this.xy,this.xy,this.radius,t.s,t.e,t.d),i.stroke(),h=this.cv==this.v),i.beginPath(),i.strokeStyle=h?this.o.fgColor:this.fgColor,i.arc(this.xy,this.xy,this.radius,s.s,s.e,s.d),i.stroke()},this.cancel=function(){this.val(this.v)}},t.fn.dial=t.fn.knob=function(s){return this.each(function(){var h=new i.Dial;h.o=s,h.$=t(this),h.run()}).parent()}});


	// COUNTER INIT
		$(function(){$(".knob").knob({draw:function(){if("tron"==this.$.data("skin")){var t,i=this.angle(this.cv),s=this.startAngle,h=this.startAngle,n=h+i,o=!0;return this.g.lineWidth=this.lineWidth,this.o.cursor&&(h=n-.3)&&(n+=.3),this.o.displayPrevious&&(t=this.startAngle+this.angle(this.value),this.o.cursor&&(s=t+.3)&&(t-=.3),this.g.beginPath(),this.g.strokeStyle=this.previousColor,this.g.arc(this.xy,this.xy,this.radius-this.lineWidth,s,t,!1),this.g.stroke()),this.g.beginPath(),this.g.strokeStyle=o?this.o.fgColor:this.fgColor,this.g.arc(this.xy,this.xy,this.radius-this.lineWidth,h,n,!1),this.g.stroke(),this.g.lineWidth=2,this.g.beginPath(),this.g.strokeStyle=this.o.fgColor,this.g.arc(this.xy,this.xy,this.radius-this.lineWidth+1+2*this.lineWidth/3,0,2*Math.PI,!1),this.g.stroke(),!1}}});var t,i=0,s=0,h=0,n=$("div.idir"),o=$("div.ival"),e=function(){h++,n.show().html("+").fadeOut(),o.html(h)},r=function(){h--,n.show().html("-").fadeOut(),o.html(h)};$("input.infinite").knob({min:0,max:20,stopper:!1,change:function(){t>this.cv?i?(r(),i=0):(i=1,s=0):t<this.cv&&(s?(e(),s=0):(s=1,i=0)),t=this.cv}})});



	jQuery(document).ready(function($) {

		var date_year = $("#timer_countdown_wrap").data('year');
		var date_month = $("#timer_countdown_wrap").data('month');
		var date_day = $("#timer_countdown_wrap").data('day');

		$("#timer_countdown").ccountdown( date_year, date_month, date_day,'00:00');

		$('.knob.days').after("<span class='countdown_caption'>" + passwordText.daysTr + "</span>");
		$('.knob.hour').after("<span class='countdown_caption'>" + passwordText.hoursTr + "</span>");
		$('.knob.minute').after("<span class='countdown_caption'>" + passwordText.minutesTr + "</span>");
		$('.knob.second').after("<span class='countdown_caption'>" + passwordText.secondsTr + "</span>");
		
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-product"]) return;
  try {
    
jQuery(document).ready(function($){
	var sectionID=$('.section_product').attr('id').replace('shopify-section-','');
    var stopAllVideos = function() {
        $('.gallery_big .video-slide').each(function() {
            if (this.tagName === 'VIDEO') {
                this.pause();
                this.currentTime = 0;
            } else if (this.tagName === 'IFRAME') {
                var src = $(this).attr('src');
                $(this).attr('src', src);
            }
        });
    };

	var productLoad=function(){
		if(productImage && theme.productViewType=='carousel'){
			var galleryImages=$('#gallery_big-'+sectionID);
			var galleryImagesPrev=$('#prev_'+sectionID);
			var galleryImagesNext=$('#next_'+sectionID);
			var galleryThumbs=$('#gallery_thumbs-'+sectionID);
            var galleryThumbSlider=new Swiper(galleryThumbs,{
                slidesPerView:5,
                breakpoints:{991:{slidesPerView:4},768:{slidesPerView:3}},
                spaceBetween:10,
                touchRatio:0.2,
                slideToClickedSlide:true,
                watchSlidesVisibility:true,
                watchSlidesProgress:true
            });
            var galleryImageSlider=new Swiper(galleryImages,{
                effect:'slide',
                speed:500,
                slideToClickedSlide:true,
                navigation:{nextEl:galleryImagesNext,prevEl:galleryImagesPrev},
                thumbs:{swiper:galleryThumbSlider},
                on: { slideChange: function () { stopAllVideos(); } }
            });
            var timeout;
			var buttons = $('.custom-swiper-btn');
			var gallery = $('.gallery_big');
			gallery.on('mousemove', function() {
				buttons.addClass('is-visible');
				clearTimeout(timeout);
				timeout = setTimeout(function() { buttons.removeClass('is-visible'); }, 2000);
			});
            gallery.on('mouseleave', function() {
				buttons.removeClass('is-visible');
				clearTimeout(timeout);
			});
		};

		var productSelect='product_select_'+sectionID;
		var productArray=JSON.parse($('#product_json_'+sectionID).html());
		var variantWeights=JSON.parse($('#variant_weights_'+sectionID).html());
		var productWeight=$('#single_product__weight-'+sectionID);
		var productSKU=$('#single_product__sku-'+sectionID);
		var productBarcode=$('#single_product__barcode-'+sectionID);
		var productAvailability=$('#single_product__availability-'+sectionID);
		var productPrice=$('#single_product__price-'+sectionID);
        var productQuantity=$('#single_product__quantity-'+sectionID);
        var productAdd=$('#single_product__addtocart-'+sectionID);

		selectCallback=function(variant,selector){
			if(variant && variant.available){
				if(variant.requires_shipping==true){for(var i in variantWeights){if(parseInt(i)==variant.id){productWeight.html(variantWeights[i]);}};}else{productWeight.html('—');};
				if(variant.sku && variant.sku.length){productSKU.html(variant.sku);}else{productSKU.html('—');};
				if(variant.barcode!=null){productBarcode.html(variant.barcode);}else{productBarcode.html('—');};
				if(variant.inventory_management!=null){
					if((variant.inventory_quantity==0)&&(variant.inventory_policy=='continue')){productAvailability.removeClass('notify_danger').addClass('notify_success').html(producText.available);}
					else{productAvailability.removeClass('notify_danger').addClass('notify_success').html(variant.inventory_quantity+' '+producText.items);};
				}else{productAvailability.removeClass('notify_danger').addClass('notify_success').html(producText.available);};
                if(window.customerDiscount && window.customerDiscount.active) {
                    var finalPrice, originalPrice;
                    if(window.customerDiscount.isFixed) {
                        originalPrice = variant.price;
                        finalPrice = originalPrice - window.customerDiscount.fixedAmount;
                        if(finalPrice < 0) finalPrice = 0;
                    } else {
                        finalPrice = variant.price * window.customerDiscount.multiplier;
                        originalPrice = variant.price;
                    }
                    var priceHtml = '';
                    if (originalPrice > finalPrice) {
                         priceHtml += '<span class="money money_old">' + Shopify.formatMoney(originalPrice, theme.moneyFormat) + '</span>';
                    }
                    priceHtml += '<span class="money money_main money_special">' + Shopify.formatMoney(finalPrice, theme.moneyFormat) + '</span>';
                    productPrice.html(priceHtml);
                } else {
                    if(variant.price < variant.compare_at_price){
                        productPrice.html('<span class="money money_old">' + Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</span>' + '<span class="money money_main">' + Shopify.formatMoney(variant.price, theme.moneyFormat) + '</span>');
                    } else {
                        productPrice.html('<span class="money money_main">' + Shopify.formatMoney(variant.price, theme.moneyFormat) + '</span>');
                    }
                }
				productQuantity.removeAttr('disabled');
				productAdd.removeAttr('disabled');
                if(productImage && theme.productViewType=='carousel'){
					if(variant.featured_media){
						var mediaId = variant.featured_media.id;
						var slideIndex = $('#gallery_big-' + sectionID + ' .swiper-slide[data-media-id="' + mediaId + '"]').index();
                        if(slideIndex >= 0){ galleryImageSlider.slideTo(slideIndex); }
					}
				};
			}else{
				productAvailability.removeClass('notify_success').addClass('notify_danger').html(producText.unavailable);
				productQuantity.attr('disabled','disabled');
				productAdd.attr('disabled','disabled');
			};
			if(typeof theme.shopCurrency!='undefined'){
				var newCurrency=Currency.cookie.read();
				var moneySelector=productPrice.find('span.money');
				Currency.convertAll(theme.shopCurrency,newCurrency,moneySelector,'money_format');
			};
			renderColorOptions(productArray.options);renderSizeOptions(productArray.options);
		};
		new Shopify.OptionSelectors(productSelect,{product:productArray,onVariantSelected:selectCallback,enableHistoryState:true});
    };

	var productLoadTrigger=true;
	$(document).on('shopify:section:load','#shopify-section-'+sectionID,function(){productLoad();productLoadTrigger=false;});
	if(productLoadTrigger){productLoad();};

	var renderColorOptions=function(options){
		var colorOptionIndex=$('.color_product__options .color_toggle').data('option-index');
        if(colorOptionIndex === undefined) return;
		var colorSelect=$('#shopify-section-'+sectionID+' .single-option-selector').eq(colorOptionIndex);
		var selectId='#'+colorSelect.attr('id');
        var container=$('#shopify-section-'+sectionID+' .color_product__options .color_toggle');
		var content='<label>'+options[colorOptionIndex]+':</label>';
		$(selectId+' option').each(function(){
			var value=$(this).val();
			colorSelect.parent('.selector-wrapper').addClass('hidden');
			if(colorSelect.val()==value){content=content+'<div class="color_item current" data-val="'+value+'" title="'+value+'"><span class="color_inner" style="background-color: '+value+'"></span></div>';}
			else{content=content+'<div class="color_item" data-val="'+value+'" title="'+value+'"><span class="color_inner" style="background-color: '+value+'"></span></div>';};
		});
        container.html(content);
		$('.color_product__options .color_item').off('click').on('click',function(e){colorSelect.val($(this).data('val')).trigger('change');});
	};

	var renderSizeOptions=function(options){
		var sizeOptionIndex=$('.size_product__options .size_toggle').data('option-index');
        if(sizeOptionIndex === undefined) return;
		var sizeSelect=$('#shopify-section-'+sectionID+' .single-option-selector').eq(sizeOptionIndex);
		var selectId='#'+sizeSelect.attr('id');
        var container=$('#shopify-section-'+sectionID+' .size_product__options .size_toggle');
		var content='<label>'+options[sizeOptionIndex]+':</label>';
		$(sizeId+' option').each(function(){
			var value=$(this).val();
			sizeSelect.parent('.selector-wrapper').addClass('hidden');
			if(sizeSelect.val()==value){content=content+'<div class="size_item current" data-val="'+value+'"><span class="size_inner">'+value+'</span></div>';}
			else{content=content+'<div class="size_item" data-val="'+value+'"><span class="size_inner">'+value+'</span></div>';};
		});
		container.html(content);
		$('.size_product__options .size_item').off('click').on('click',function(e){sizeSelect.val($(this).data('val')).trigger('change');});
	};
    if(theme.productRelatedView){
		var productRelatedSlider=new Swiper('#widget_related_slideshow',{
            effect:'slide',
            slidesPerView: 4,
            spaceBetween:20,
            speed:500,
            breakpoints:{ 1200: { slidesPerView: 4 }, 992: { slidesPerView: 3 }, 768: { slidesPerView: 2 }, 576: { slidesPerView: 1 } },
            pagination:{el:'.widget_related_slideshow_pagination',type:'bullets',clickable:true}
        });
	}

	$('.tab_nav').on('click', function(){
		var index = $(this).data('tab');
		$('.tab_nav').removeClass('active');
		$(this).addClass('active');
		$('.tab_item').removeClass('active').hide();
		$('.tab_item').eq(index).addClass('active').fadeIn();
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-wishlist"]) return;
  try {
    
jQuery(document).ready(function($) {

	var isCustomer = $('#wishlist_page').data('customer')
	
		if ( isCustomer ) {
		
			if ($('.product_wishlist').length == 0) {
				$('#wishlist_empty').removeClass('hidden');
	 			$('#wishlist_products_number').html( 0 );
			}
	 		else {
	 			$('#wishlist_products_number').html( $('.product_wishlist').length );
	 		};
		}		 		
		 	
});

  } catch(e) { console.error(e); }
})();
})();
